export default __webpack_public_path__ + "static/part1_6mb-129e44d26b86ad549c61c7ed56016085.png";